import { render, staticRenderFns } from "./ProductsPage.vue?vue&type=template&id=658613b4"
import script from "./ProductsPage.vue?vue&type=script&lang=js"
export * from "./ProductsPage.vue?vue&type=script&lang=js"
import style0 from "./ProductsPage.vue?vue&type=style&index=0&id=658613b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports